import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _circle, _circle2;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgDeliveroo = function SvgDeliveroo(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M14.236 5.889a.025.025 0 0 0-.027.022l-.554 5.21c-.003.027-.043.03-.05.002l-.937-4.366a.025.025 0 0 0-.03-.02l-3.027.63a.025.025 0 0 0-.02.03l.956 4.494a.025.025 0 0 1-.02.03l-4.375.92a.025.025 0 0 0-.02.03l.779 3.582c.002.01.01.017.019.02l7.76 1.637a.025.025 0 0 0 .027-.015l1.772-3.926a.025.025 0 0 0 .002-.008l.842-7.924a.025.025 0 0 0-.022-.028l-3.075-.32Z",
      stroke: "currentColor",
      strokeWidth: 1.3
    })), _circle || (_circle = /*#__PURE__*/_jsx("circle", {
      cx: 11.553,
      cy: 13.515,
      r: 0.667,
      fill: "currentColor"
    })), _circle2 || (_circle2 = /*#__PURE__*/_jsx("circle", {
      cx: 13.341,
      cy: 14.428,
      r: 0.667,
      fill: "currentColor"
    }))]
  }));
};
export default SvgDeliveroo;